<template>
    <div>
        <ModalComponent
            :name="'editar-' + indumentaria.id"
            :title="'Editar la indumentaria ' + indumentaria.nombre"
            v-on:close="() => close"
            v-if="!loading"
        >
            <h4 class="pb-4 text-center">Editar la indumentaria: {{ indumentaria.nombre }}</h4>
            <b-row class="m-0">
                <b-col cols="12" class="mb-3">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="recogida" v-model="indumentaria.pivot.recogida">
                        <label class="custom-control-label pt-1" for="recogida">Marcar como recogida</label>
                    </div>
                </b-col>
                <b-col cols="12">
                    <FormInput label="Observaciones recogida" type="text" v-model="indumentaria.pivot.observaciones" />
                </b-col>
                <b-col v-if="puedeCambiar" cols="12" class="mt-2">
                    <table width="100%" class="mb-3">
                        <thead>
                            <tr>
                                <th class="text-center">Talla</th>
                                <th class="text-center">Cantidad</th>
                                <th class="text-center">Opciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text-center">{{ indumentaria.tallaSelect ? indumentaria.tallaSelect.nombre : (indumentaria.talla ? indumentaria.talla.nombre : '') }}</td>
                                <td class="text-center">{{ indumentaria.stockSelect ? indumentaria.stockSelect : indumentaria.pivot.cantidad }}</td>
                                <td class="text-center">
                                    <b-btn @click="showModal('cambiar-talla')">Cambiar talla</b-btn>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <CambiarTalla :indumentaria="indumentaria" @talla-cambiada="tallaCambiada" @close="closeCambiarTalla()"></CambiarTalla>
                </b-col>
                <b-col cols="12">
                    <b-btn @click="editar()">Guardar</b-btn>
                </b-col>
            </b-row>
        </ModalComponent>
        <LoaderComponent v-else></LoaderComponent>
    </div>
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";
import CambiarTalla from './CambiarTalla';

export default {
    props: ['indumentaria'],
    data() {
        return {
            loading: false,
            editar_talla: false,
            fields: [
                { key: 'nombre', label: 'Nombre', class: 'text-center' },
                { key: 'opciones', label: 'Opciones', class: 'text-center' }
            ]
        }
    },
    methods: {
        close() {
            this.$emit('close', 'editar-' + this.indumentaria.id);
        },
        closeCambiarTalla() {
            this.$emit('close', 'cambiar-talla');
        },
        showModal(modal) {
            this.$modal.show(modal);
        },
        tallaCambiada() {
            this.$forceUpdate();
        },
        editarTalla() {
            if (this.indumentaria.talla) {
                this.editar_talla = !this.editar_talla;
            } 
        },
        editar() {
            this.loading = true;

            var params = {
                filters : {},
                lista_id: this.lista_id,
                base_id: this.$route.params.base_id,
                indumentaria_id: this.indumentaria.indumentaria_id,
                indumentariaSelect: this.indumentaria
            }

            this.$store.dispatch(this.config.getVuexAlias('back.bases.indumentaria_base.update'), params).then(res => {
                this.$toast.success(res.data.message, {});
                this.$emit('actualizar');
                this.close();
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            }).finally(() => this.loading = false);
        }
    },
    computed: {
        puedeCambiar() {
            if (this.indumentaria.pivot.incluida || this.indumentaria.pivot.recogida) {
                return false;
            } else {
                return true;
            }
        },
        lista_id() {
            return this.$route.params.lista_id;
        }
    },
    components: {
        ModalComponent, CambiarTalla
    }
}
</script>
